import {Message} from "../locale/Message";
import moment from "moment";

export const formatDate = (date, date_format) => {
  if (!date)
    return "";
  return moment(new Date(date)).format(date_format);
};

export function getResult(state, fun) {
  let result = {...state};
  fun(result);
  return result;
}

export function isNeedReload(obj) {
  return !obj || obj.processing || obj.error;
}

export function isNeedReloadInArray(obj, key) {
  return !obj || !obj[key] || obj[key].processing || obj[key].error;
}

export function getState(state, lang) {
  if (state === 'ACTIVE') {
    return Message[lang].active;
  } else {
    return Message[lang].suspended;
  }
}

export function getMethod(method, lang) {
  if (method === 'POSTPAID') {
    return Message[lang].postpaid;
  } else {
    return Message[lang].pia;
  }
}

export function isNeedClear(obj) {
  return obj && (obj.processing || obj.error);
}

export function checkAuth(state) {
  const {authorization, lang} = state;
  if (!authorization.processing && (!authorization.isAuth || !authorization.expDate || authorization.expDate < (new Date().getTime())))
    window.location.replace(`${window.location.protocol}//${window.location.host}/${lang}/b2b.account/login/2537`);
}

export function notNull(obj, ...args) {
  if (!obj)
    return false;
  let lastObj = obj;
  for (let i = 0; i < args.length; i++) {
    lastObj = lastObj[args[i]];
    if (!lastObj)
      return false;
  }
  return lastObj;
}

export const formatMsisdn = msisdn => {
  msisdn = msisdn.length == 10 ? '7'.concat(msisdn) : msisdn;
  if (msisdn.length < 11)
      return null;
  msisdn = msisdn.replace(/[^0-9]/g, "");
  return '+7 '.concat(msisdn.slice(1, 4)).concat(' ').concat(msisdn.slice(4, 7)).concat(' ')
      .concat(msisdn.slice(7, 9)).concat(' ').concat(msisdn.slice(9, 11));
};

export const numeric = value => value.toString().replace(/[^0-9]/g, "");

export const real = value => {
  const valueToString =value.toString().replace('.', ',').replace(/[^0-9,]/g, "")
  if(valueToString.includes(',') && (valueToString.length - ((valueToString.indexOf(',') +1 ))) > 2) {
    return  'error'
  }  else if(parseFloat(valueToString.replace(',', '.')) === 0.0 ) {
    return 'error'
  }
  return valueToString;
}